module.exports = __webpack_public_path__ + "static_assets/media/bell6.352f1fd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bell6.mp3
// module id = 8ucF
// module chunks = 40